import ExamIncompleteExercisesScreen from './ExamIncompleteExercisesScreen';
import ExamCongratulationsScreen from './ExamCongratulationsScreen';
import ExamCertificationExpiredScreen from './ExamCertificationExpiredScreen';
import ExamAttemptExpiredScreen from './ExamAttemptExpiredScreen';
import ExamAttemptExpiredIncompleteExercisesScreen from './ExamAttemptExpiredIncompleteExercisesScreen';
import ExamAwardNotGeneratedScreen from './ExamAwardNotGeneratedScreen';
import ExamAttemptFailedScreen from './ExamAttemptFailedScreen';
import { getExamIsRecent, getIsExamAttemptExpired, getProbablyHasCert, isExpired } from '../examsUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const useExamFinishedScreen = (track, mostRecentExamAttempt, pendingPracticalExercises, award) => {
  const isAwardExpired = isExpired(award === null || award === void 0 ? void 0 : award.expiresAt);
  const {
    isAttemptExpired
  } = getIsExamAttemptExpired(mostRecentExamAttempt);
  const probablyHasCert = getProbablyHasCert(track, mostRecentExamAttempt, pendingPracticalExercises);
  const examIsRecent = getExamIsRecent(mostRecentExamAttempt);
  const attemptFinished = mostRecentExamAttempt.attemptFinishTime != null;
  const certificationExpired = !examIsRecent && isAwardExpired;
  const practicalExercisesFinished = !(pendingPracticalExercises !== null && pendingPracticalExercises !== void 0 && pendingPracticalExercises.length);
  const awardNotYetLoaded = !award && probablyHasCert && examIsRecent;
  const passed = mostRecentExamAttempt.passed;
  return {
    isAwardExpired,
    isAttemptExpired,
    passed,
    attemptFinished,
    practicalExercisesFinished,
    awardNotYetLoaded,
    certificationExpired
  };
};
const ExamFinishedScreen = ({
  award,
  track,
  certificationAwardedInDifferentLanguage,
  mostRecentExamAttempt,
  pendingPracticalExercises
}) => {
  const {
    isAwardExpired,
    isAttemptExpired,
    passed,
    attemptFinished,
    practicalExercisesFinished,
    awardNotYetLoaded,
    certificationExpired
  } = useExamFinishedScreen(track, mostRecentExamAttempt, pendingPracticalExercises, award);
  if (passed && attemptFinished && !isAttemptExpired && !isAwardExpired && !practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamIncompleteExercisesScreen, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      track: track
    });
  }
  if (passed && practicalExercisesFinished && !certificationExpired && (awardNotYetLoaded || award)) {
    return /*#__PURE__*/_jsx(ExamCongratulationsScreen, {
      certificationAwardedInDifferentLanguage: certificationAwardedInDifferentLanguage,
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      track: track
    });
  }
  if (passed && certificationExpired && practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamCertificationExpiredScreen, {
      award: award,
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      track: track
    });
  }
  if (passed && isAttemptExpired && practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamAttemptExpiredScreen, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      track: track
    });
  }
  if (passed && isAttemptExpired && !practicalExercisesFinished) {
    return /*#__PURE__*/_jsx(ExamAttemptExpiredIncompleteExercisesScreen, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      track: track
    });
  }

  // Award failed to generate
  if (passed && !award) {
    return /*#__PURE__*/_jsx(ExamAwardNotGeneratedScreen, {
      mostRecentExamAttempt: mostRecentExamAttempt,
      pendingPracticalExercises: pendingPracticalExercises,
      track: track
    });
  }
  return /*#__PURE__*/_jsx(ExamAttemptFailedScreen, {
    award: award,
    mostRecentExamAttempt: mostRecentExamAttempt,
    pendingPracticalExercises: pendingPracticalExercises,
    track: track
  });
};
export default ExamFinishedScreen;